import { Reveal } from "./Reveal";
import { CASES } from "../../config";

const proof = CASES.slice(0, 4);

const spotlight = (e) => {
  const r = e.currentTarget.getBoundingClientRect();
  e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
  e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
};

export const Proof = () => (
  <section data-testid="proof" className="relative z-10 py-20 sm:py-28 bg-[var(--surface)] border-b border-white/10">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <div className="flex items-end justify-between gap-6 mb-12">
          <div>
            <p className="overline mb-3">Prueba visual</p>
            <h2 className="font-display font-bold tracking-tight text-2xl sm:text-3xl">
              Proyectos que ya viven en producción
            </h2>
          </div>
          <a href="#casos" className="hidden sm:inline text-sm text-zinc-400 hover:text-white transition-colors duration-200 shrink-0">
            Ver todos →
          </a>
        </div>
      </Reveal>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {proof.map((c, i) => (
          <Reveal key={c.id} delay={i * 0.08}>
            <div
              onMouseMove={spotlight}
              data-testid={`proof-card-${c.id}`}
              className="spotlight-card hover-lift group rounded-2xl overflow-hidden border border-white/10 bg-black"
            >
              <div className="overflow-hidden">
                <img
                  src={c.proofImage || c.image}
                  alt={c.name}
                  loading="lazy"
                  className="w-full h-auto block opacity-90 group-hover:opacity-100 transition-opacity duration-500"
                />
              </div>
              <div className="p-4 relative z-[3]">
                <p className="text-[0.7rem] uppercase tracking-widest text-[var(--magenta)]">{c.typeLabel}</p>
                <p className="font-medium mt-1 text-sm">{c.name}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
